import { Button } from "antd";
import React from "react";

function Page404() {
  const containerStyle = {
    maxWidth: "600px",
    padding: "20px",
    width: "100%",
    backgroundColor: "#fff",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
    display: "flex",
    rowGap: "8px",
    flexDirection: "column",
    borderRadius: "8px",
  };

  const headingStyle = {};
  const goBackTwoTimes = () => {
    window.history.go(-2);
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100vh",
      }}
    >
      <div style={containerStyle}>
        <h2 style={headingStyle}>404 Not Found</h2>
        <p>Sorry, the page you are looking for does not exist.</p>
        <Button onClick={goBackTwoTimes}>Go Back</Button>
      </div>
    </div>
  );
}

export default Page404;
